import { MODE } from "../constants/mode"
import { getIsMobileMode } from "./responsive"

export const getMode = (): MODE => {
    const isKioskMode = window.location.search.includes('kiosk-mode')
    if(isKioskMode) {
        return MODE.KIOSK
    }

    const isMobile = getIsMobileMode()
    if (isMobile) {
        return MODE.MOBILE
    }

    return MODE.DESKTOP
}